// Smooth scroll to element on page load if hash exists in URL
document.addEventListener('DOMContentLoaded', () => {
  const hash = window.location.hash;
  if (hash) {
    const targetId = hash.substring(1); // Remove '#' from the hash
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      setTimeout(() => {
        scrollToTarget(targetElement);

        // Open the accordion if it's a collapsible section
        if (targetElement.classList.contains('accordion-collapse')) {
          targetElement.classList.add('show'); // Open the accordion
          const button = document.querySelector(`[data-bs-target="#${targetId}"]`);
          if (button) {
            button.classList.remove('collapsed'); // Ensure the button state is correct
          }
        }
      }, 0); // Delay to ensure DOM is ready
    }
  }
});

// Smooth scroll to clicked anchor link
document.querySelectorAll('a[href*="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const targetUrl = this.getAttribute('href');
    if (isSamePageAnchor(targetUrl)) {
      e.preventDefault(); // Prevent default anchor behavior

      const targetId = targetUrl.substring(targetUrl.indexOf('#') + 1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        scrollToTarget(targetElement);

        // Open the accordion if it's a collapsible section
        if (targetElement.classList.contains('accordion-collapse')) {
          targetElement.classList.add('show'); // Open the accordion
          const button = document.querySelector(`[data-bs-target="#${targetId}"]`);
          if (button) {
            button.classList.remove('collapsed'); // Ensure the button state is correct
          }
        }

        // Optionally, close the menu if it's a navigation link
        if (this.classList.contains('nav-link')) {
          collapseMenu();
        }
      }
    }
  });
});

// Function to scroll to target element smoothly
function scrollToTarget(target) {
  target.scrollIntoView({ behavior: 'smooth' });
}

// Function to check if the anchor is on the same page
function isSamePageAnchor(anchorUrl) {
  const currentPageUrl = window.location.href.split('#')[0];
  const targetPageUrl = anchorUrl.split('#')[0];
  return currentPageUrl === targetPageUrl;
}
